import { render, staticRenderFns } from "./SearchDossierResults.vue?vue&type=template&id=76f64390&scoped=true&"
import script from "./SearchDossierResults.vue?vue&type=script&lang=ts&"
export * from "./SearchDossierResults.vue?vue&type=script&lang=ts&"
import style0 from "./SearchDossierResults.vue?vue&type=style&index=0&id=76f64390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f64390",
  null
  
)

export default component.exports